/* This file is autogenerated, see readme.md for instructions */
import DocumentationSvgIcon from '@bloomreach/banana-theme/icons/documentation.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DocumentationIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DocumentationSvgIcon />
    </Icon>
  );
});

DocumentationIcon.displayName = 'DocumentationIcon';

export default DocumentationIcon;
